/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type BuySharedBreadcrumbs_buyPage$ref = any;
export type BuySharedBreadcrumbs_buyPage = {
    readonly breadcrumbs: ReadonlyArray<{
        readonly path: string | null;
        readonly displayName: string | null;
    } | null> | null;
    readonly " $refType": BuySharedBreadcrumbs_buyPage$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "BuySharedBreadcrumbs_buyPage",
    "type": "BuyPageConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "breadcrumbs",
            "storageKey": null,
            "args": null,
            "concreteType": "SearchBrowseBreadcrumbs",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "path",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "displayName",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'cdf60cb5a8c3ff25d4e52da77281c6d8';
export default node;
